import { render, staticRenderFns } from "./markInfo.vue?vue&type=template&id=e6e6dd7c&scoped=true"
import script from "./markInfo.vue?vue&type=script&lang=js"
export * from "./markInfo.vue?vue&type=script&lang=js"
import style0 from "./markInfo.vue?vue&type=style&index=0&id=e6e6dd7c&prod&lang=scss"
import style1 from "./markInfo.vue?vue&type=style&index=1&id=e6e6dd7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6e6dd7c",
  null
  
)

export default component.exports